import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {
    ConditionlDelayBlockModel,
    IConditionlDelayBlockModel
} from "@app/workflow-common/services/models/ConditionlDelayBlockModel";

@Component({
  selector: 'app-conditional-delay-block-widget',
  templateUrl: './conditional-delay-block-widget.component.html',
  styles: []
})
export class ConditionalDelayBlockWidgetComponent implements OnInit {

    @Input() workflowType: string;
    @Input() blockObject;
    @Input() dagSourceModel: DagSourceModel;
    @Input() objectName: string;
    @Input() isConditional:boolean = false;
    @Input() conditionalColName: string = '';
    @Output() close:EventEmitter<{}> = new EventEmitter<{}>();

    blockName:string = 'conditionalDelayBlock';
    form: FormGroup;
    isFormSubmitted: boolean = false;
    conditionalDelayBlockData:{} = {};
    showDeleteBtn: boolean = false;
    isReadOnlyMode: boolean = false;
    inputModel: IConditionlDelayBlockModel = undefined;
    units:string[] = ['Minutes','Hours', 'Days', 'Months'];
    minutesInterval: any[] = Array.from(Array(60).keys());
    hoursInterval: any[] = Array.from(Array(24).keys());
    daysInterval: any[] = Array.from(Array(31).keys());
    monthsInterval: any[] = Array.from(Array(13).keys());
    fields: any[];
    constructor(
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit() {
        this.conditionalDelayBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
        this.fields = Object.values(this.dagSourceModel.getFieldMetadata()).filter( item => item['type'] === 'date');
        const blockObject = {...this.blockObject};
        const modelData = blockObject['model'] ? blockObject['model'] : undefined;
        if(modelData) {
            this.showDeleteBtn=true;
        }
        this.inputModel = new ConditionlDelayBlockModel(modelData);

        const formGroupConfig = {
            interval: new FormControl(this.inputModel.interval, [Validators.required, (control: AbstractControl): ValidationErrors | null => {
                const forbidden = control.value == 0;
                return forbidden ? {notAllowed: {value: control.value}} : null;
            }]),
            type: new FormControl(this.inputModel.type),
            unit: new FormControl(this.inputModel.unit, [Validators.required]),
            event_method: new FormControl(this.inputModel.event_method, [Validators.required]),
            col_name: new FormControl(this.inputModel.col_name, [Validators.required]),
            fieldLabel: new FormControl(this.inputModel.fieldLabel, [Validators.required]),
        };

        if(this.isConditional) {
            formGroupConfig['condition'] = this.formBuilder.group({});
        }
        this.form = this.formBuilder.group(formGroupConfig);
    }

    onChangeUnit(event:any) {
        if( (this.form.get('unit').value == 'Months' && this.form.get('interval').value > 12)
            || (this.form.get('unit').value == 'Days' && this.form.get('interval').value > 30)
            || (this.form.get('unit').value == 'Hours' && this.form.get('interval').value > 23)){
            this.form.get('interval').setValue(0);
        }
    }

    onChangeField(event) {
        const currentField = this.fields.find(field => field['col_name'] == event);
        if(currentField) {
            this.form.get('fieldLabel').setValue(currentField['text']);
        }
    }

    save() {
        this.isFormSubmitted=true;
        const blockObject = {...this.blockObject};

        blockObject.model = new ConditionlDelayBlockModel(this.form.value);
        const { condition } = this.form.value;
        if(this.isConditional) {
            blockObject['condition'] = condition;
            blockObject['isConditional'] = true;
        }
        console.log('xzxc', blockObject)
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        })
    }

    closeModal() {
        this.close.emit({
            action: 'close',
            data: null
        });
    }

    remove() {
        const blockObject = {...this.blockObject};
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    }

}
